export const MY_TEAM_GET_USERS = "MY_TEAM_GET_USERS"
export const MY_TEAM_GET_USERS_SUCCESSFULL = "MY_TEAM_GET_USERS_SUCCESSFULL"
export const MY_TEAM_GET_USERS_FAILED = "MY_TEAM_GET_USERS_FAILED"
export const MY_TEAM_DELETE_USER = "MY_TEAM_DELETE_USER"
export const MY_TEAM_DELETE_USER_SUCCESSFULL = "MY_TEAM_DELETE_USER_SUCCESSFULL"
export const MY_TEAM_DELETE_USER_FAILED = "MY_TEAM_DELETE_USER_FAILED"
export const ALL_MY_TEAM_GET_USERS = "ALL_MY_TEAM_GET_USERS"
export const MY_TEAM_ISACTIVE_FAILED = "MY_TEAM_ISACTIVE_FAILED"
export const MY_TEAM_ISACTIVE_SUCCESS = "MY_TEAM_ISACTIVE_SUCCESS"
export const MY_TEAM_ISACTIVE = "MY_TEAM_ISACTIVE"

export const MY_TEAM_RESEND_VERIFICATION_EMAIL = "MY_TEAM_RESEND_VERIFICATION_EMAIL"
export const MY_TEAM_RESEND_VERIFICATION_EMAIL_SUCCESS = "MY_TEAM_RESEND_VERIFICATION_EMAIL_SUCCESS"
export const MY_TEAM_RESEND_VERIFICATION_EMAIL_FAILED = "MY_TEAM_RESEND_VERIFICATION_EMAIL_FAILED"

export const GET_SAMPLE_CSV_USERS = "GET_SAMPLE_CSV_USERS"
export const GET_SAMPLE_CSV_USERS_SUCCESS = "GET_SAMPLE_CSV_USERS_SUCCESS"
export const GET_SAMPLE_CSV_USERS_FAILED = "GET_SAMPLE_CSV_USERS_FAILED"
export const POST_CSV_USERS = "POST_CSV_USERS"
export const POST_CSV_USERS_SUCCESS = "POST_CSV_USERS_SUCCESS"
export const POST_CSV_USERS_FAILED = "POST_CSV_USERS_FAILED"

